// import React, { useState, useEffect } from "react";
// import CustomButton from "../../../components/AddButton";
// import { edit, Plus, map, placeMareker } from "../../../common/svg";
// import { TripDetails } from "../../../common/staticData";
// import CustomCard from "../../../components/Card";
// // import Carousel from "../../../components/Carousel/index"
import DaysLeftCounter from "../../../components/DaysProgress";
// import CustomChip from "../../../components/Chip";
// import SecureImage from "../../../components/BucketImage/Image";
// import DeliveryTimeline from "../../../components/DeliveryTimeline";
// import { ApiService } from "../../../service/api.service";
// import { OPERTIONS_URL } from "../../../common/common";

import { useEffect, useState } from "react";
import { ApiService } from "../../../service/api.service";
import { OPERTIONS_URL } from "../../../common/common";
import CustomButton from "../../../components/AddButton";
import { edit, map, placeMareker, Plus } from "../../../common/svg";
import CustomCard from "../../../components/Card";
import CustomChip from "../../../components/Chip";
import moment from "moment";
import SecureImage from "../../../components/BucketImage/Image";
import DeliveryTimeline from "../../../components/DeliveryTimeline";

// import moment from "moment";
interface RoutesProps {
  id: any;
}

interface RouteDetail {
  routeId: string;
  pickupPoint: string;
  loadingPoint: string;
  unloadingPoint: string;
  clearancePoint: string;
  pickupAt: string;
  loadingAt: string;
  unloadingAt: string;
  clearanceAt: string;
  distanceKm: number;
  // Add other properties as needed
}

interface TripData {
  tripDetail: {
    tripId: string;
    bookingId: string;
    tripName: string;
    startingDateTime: string;
    tripNumber: string;
    daysLeft: number;
    routes: Array<{
      tripId: string;
      routeDetails: RouteDetail;
    }>;
  };
}

const Routes = ({ id }: RoutesProps) => {
  const apiService = new ApiService();
  const [activeTripCard, setActiveTripCard] = useState<number | null>(null);
  const [viewTripDetails, setViewTripDetails] = useState<boolean>(false);
  const [isWhite, setIsWhite] = useState(false);
  const [tripData, setTripData] = useState<any[]>([]);

  useEffect(() => {
    const handleClick = () => setIsWhite(true);
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);

  const handleClick = () => {
    console.log("Button clicked!");
  };

  const handleViewDetails = (index: number) => {
    setActiveTripCard(index);
    setViewTripDetails(true);
  };

  const [isEditing, setIsEditing] = useState(false);
  const [routeInfo, setRouteInfo] = useState({
    code: "EN14245",
    start: "Chennai Manali Yard",
    end: "Ennore Port",
  });

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const parts = value.split(" – "); // Split input by " – "

    if (parts.length === 3) {
      setRouteInfo({
        code: parts[0],
        start: parts[1],
        end: parts[2],
      });
    }
  };

  const handleBlur = () => {
    setIsEditing(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response: any = await apiService.getApi(`${OPERTIONS_URL}/trip/route-all-route?bookingId=${id}`);
        console.log("Fetched Routes:", response.body.data);
        setTripData(response.body.data);
      } catch (error) {
        console.error("Error fetching routes:", error);
      }
    };

    fetchData();
  }, [id]);

  // Utility to truncate text with ellipsis
  const truncateText = (text: string, maxLength: number) => {
    if (!text) return '';
    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
  };

  return (
    <div>
      <div className="bg-white p-2 mt-3 rounded-[20px]">
        <div className="flex justify-between border-b border-[#C1C1C1] border-dashed p-2">
          <p className="text-[#282828] text-[16px] font-[600]">
            Route Points
          </p>
          <CustomButton label="" icon={Plus} onClick={handleClick} />
        </div>
        <br />
        <div className="flex gap-2 mt-">
          {/* Left */}
          <div>
  {tripData.length > 0 ? (
    tripData?.map((trip, index) => (
      <CustomCard
        key={index}
        onClick={() => handleViewDetails(index)}
        isActive={activeTripCard === index}
        className="w-[400px] shadow-[1px_-1px_3.6px_2px_#00000033] p-2 rounded"
      >
        <div className="gap-[-1]">
          {/* Top Section: Booking Name and Trip Status */}
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-2">
              <p className="font-poppins text-[14px] ">
                {truncateText(trip?.loadingPoint, 10) || 'Loading Point'}
                {' -'}
                {truncateText(trip?.unloadingPoint, 10) || 'Unloading Point'}
              </p>
              <br/>
              <CustomChip
                text="Active"
                textColor="#04D900"
                borderColor="#04D900"
              />
            </div>
            <p className="font-[400] text-[14px]">#0{index + 1}</p>
          </div>
          {/* Booking Details */}
          <div className="flex justify-between">
            <div className="leading-[18px] felx flex-col items-start">
              <span>Empty to Warehouse</span>
              <br/>
              <span className=" font-[500]">
                {trip.bookingId ? `Booking: ${trip.bookingId.slice(0, 15)}...` : 'No Trip Name'}
                {/* {trip.bookingId ? `Booking: ${trip.bookingId.slice(0, 8)}...` : 'No Trip Name'} */}
              </span>
              <p className="font-poppins font-normal italic text-[15px] mt-1">
                {trip.createdAt ? moment(trip.createdAt).format("DD MMMM YYYY, hh:mma") : 'No Date Available'}
              </p>
            </div>
            <div className="flex items-center flex-col justify-center">
              <DaysLeftCounter totalDays={trip.daysLeft || 0} />
              <p className="text-[14px] font-[400]">Days Running</p>
            </div>
          </div>

          {/* Client Name with Conditional Styling */}
          <div className="flex justify-between items-end">
            <div className="flex flex-col leading-[15px]">
              <p className="text-[14px]">Route Mode</p>
              <p
                className={`font-medium text-[14px] ${
                  activeTripCard === index ? "text-[# ]" : "text-[# ]"
                }`}
              >
                {trip.routeId ? 'Land (Road)' : 'Route Mode'}
              </p>
            </div>

            <div className="leading-[15px]">
              <p
                className={`text-[14px] ml-4 font-[300] ${
                  isWhite ? "" : ""
                }`}
              >
                Total {trip.distanceKm || 0} Kms
              </p>
              <p className="text-[16px] ml-6 font-[600] flex items-center">
                Chennai
                <SecureImage
                  fileKey={placeMareker}
                  alt="Over Speed"
                  width="25px"
                />
              </p>
            </div>
          </div>
        </div>
      </CustomCard>
    ))
  ) : (
    <p className="text-gray-500 text-center">
      No routes available. Please add a route to view details.
    </p>
  )}
</div>
          {viewTripDetails && (
            <div className="mt-[-20px] w-full border-l border-[#C1C1C1] border-dashed">
              {viewTripDetails && (
                <div className="flex flex-col w-full">
                  <div className="flex justify-between w-full p-2"></div>
                  <div className="p-2 flex flex-col gap-4">
                    <div className="flex items-center justify-between p-2 w-full">
                      <p className="text-gray-700 text-sm font-medium ml-6">
                        Route 1
                      </p>
                      <div className="border border-gray-300 rounded-lg px-4 py-2 w-[500px] h-[40px] mr-[230px]">
                        {isEditing ? (
                          <input
                            type="text"
                            name="route"
                            value={`${routeInfo.code} – ${routeInfo.start} – ${routeInfo.end}`}
                            onChange={handleInputChange}
                            onBlur={handleBlur}
                            className="text-black text-sm font-semibold w-full bg-transparent outline-none"
                            autoFocus
                          />
                        ) : (
                          <p className="text-black text-sm font-semibold">
                            <span className="font-bold">{routeInfo.code}</span>{" "}
                            –{" "}
                            <span className="font-medium">
                              {routeInfo.start}
                            </span>{" "}
                            –{" "}
                            <span className="font-medium">{routeInfo.end}</span>
                          </p>
                        )}
                      </div>
                      <CustomButton
                        label=""
                        icon={edit}
                        onClick={handleEditClick}
                      />
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="">
                      <DeliveryTimeline />
                    </div>
                    <div className="w-[400px] h-[500px] rounded-[20px] mt-6">
                      <SecureImage
                        fileKey={map}
                        alt="header icon"
                        width="400px"
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Routes;